import React, {
    useCallback, useContext
} from 'react'
import { toast } from 'react-toastify'

import { api, authHeaders } from '../../../services/api'
import { GlobalContext } from '../../../contexts/GlobalContext'
import Spinner from '../../../components/Spinner'
import { File } from '../../../components/Form'
import {
    Container, AvatarContainer
} from './styles'
import avatarDefault from '../../../assets/images/avatar.png'
import Card from '../../../components/Card'

export default function () {
    const { user, reload } = useContext(GlobalContext)

    const updateAvatar = useCallback(async fileId => {
        try {
            await api.put('usuario', { avatar_id: fileId }, authHeaders())

            reload()

            toast.success('Imagem de perfil atualizada.')
        } catch (e) {
            toast.error('Erro ao atualizar a foto de perfil.')
        }
    }, [])

    return (
        <Container className="px-1 py-1 md:px-8 md:py-4 lg:px-24 lg:py-12">
            <Card className="animated fadeIn bg-white text-slate-800">
                <h1 className="text-slate-800">Perfil de usuário</h1>

                {user ? (
                    <AvatarContainer>
                        <File
                            getPreloadImage={() => user?.avatar || avatarDefault}
                            onSuccess={updateAvatar}
                            accept={['image/*']}
                            placeholderText="Selecione um avatar"
                            previewSize="180px"
                        />
                    </AvatarContainer>
                ) : (
                    <Spinner size={30} />
                )}
            </Card>
        </Container>
    )
}
